<template>
  <el-popover
    ref="elPopover"
    v-model="value_"
    placement="bottom-start"
    :width="minWidth"
    :visible-arrow="false"
    trigger="manual"
    :popper-options="popperOptions"
    :popper-class="popperClass_"
  >
    <slot></slot>
  </el-popover>
</template>

<script type="text/babel">

import {Popover} from 'element-ui'

export default {
  name: 'SelectDropdown',
  componentName: 'SelectDropdown',
  components: {
    ElPopover: Popover
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    boundariesPadding: {
      type: Number,
      default: 0
    },
    popperOptions: {
      type: Object,
      default() {
        return {
          gpuAcceleration: false
        }
      }
    },
    appendToBody: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      minWidth: ''
    }
  },
  computed: {
    value_: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    },
    popperClass_() {
      let popperClass = `el-select-dropdown search-select `
      if (this.$parent.multiple) {
        popperClass += ' is-multiple'
      }
      if (this.$parent.popperClass) {
        popperClass += ` ${this.$parent.popperClass}`
      }
      return popperClass
    }
  },
  watch: {
    '$parent.inputWidth'() {
      this.minWidth = this.$parent.$el.getBoundingClientRect().width + 'px'
      this.$refs.elPopover.$refs.popper.style.minWidth = this.minWidth
    }
  },
  mounted() {
    // 点击改DOM元素不算失焦
    this.$parent.popperElm = this.$refs.elPopover.$refs.popper
    // 弹窗定义基于的DOM元素
    this.$refs.elPopover.referenceElm = this.$parent.$refs.reference.$el
    // 弹窗内容DOM元素
    this.$refs.elPopover.popperElm = this.$refs.elPopover.$refs.popper
    // 设置最小宽度
    this.$refs.elPopover.$refs.popper.style.minWidth = this.minWidth
    // 设置appendToBody值
    this.$refs.elPopover.appendToBody = this.appendToBody
    this.$on('updatePopper', () => {
      if (this.$parent.visible) this.$refs.elPopover.updatePopper()
    })
  }
}
</script>
